"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockResponseTarget = void 0;
const utils_1 = require("../utils");
function mockResponseTarget() {
    return {
        requestUid: utils_1.weakRandomChars(),
        browserWindowUid: utils_1.weakRandomChars(),
    };
}
exports.mockResponseTarget = mockResponseTarget;
//# sourceMappingURL=mock-response-target.js.map